import { Props } from '~/containers/AdditionalVehicleDetails';

function meetsDataDependencies(props: Props) {
  const {
    application: { autoApplicants, vehicles },
  } = props;

  return autoApplicants.length > 0 && vehicles.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/additional-vehicle-details',
  breadcrumbStep: 'auto',
  isAccessible: ({ application }: Props): boolean => application.bundled || application.isAutoOnly,
  meetsDataDependencies,
};

export default step;
